import { ChipTheme } from '../../types';

export const CHIP_DEFAULT_THEME: ChipTheme = {
    size: {
        '2xs': {
            height: 24,
            paddingX: 6,
            fontSize: 'xs',
            iconSize: 12,
            iconClearance: 4,
            radius: 5,
        },
        xs: {
            height: 28,
            paddingX: 8,
            fontSize: 'xs',
            iconSize: 16,
            iconClearance: 4,
            radius: 5,
        },
        s: {
            height: 36,
            paddingX: 12,
            fontSize: 'xs',
            iconSize: 16,
            iconClearance: 4,
            radius: 5,
        },
        m: {
            height: 40,
            paddingX: 16,
            fontSize: 's',
            iconSize: 18,
            iconClearance: 6,
            radius: 10,
        },
        l: {
            height: 48,
            paddingX: 20,
            fontSize: 'm',
            iconSize: 20,
            iconClearance: 8,
            radius: 10,
        },
    },
    fontWeight: 'semiBold',
    borderWidth: 1,
    colors: {
        primary: {
            backgroundFilled: 'primary.base',
            border: 'primary.base',
            textFilled: 'common.white',
            textOutlined: 'primary.base',
        },
        secondary: {
            backgroundFilled: 'secondary.base',
            border: 'secondary.base',
            textFilled: 'common.white',
            textOutlined: 'secondary.base',
        },
        tertiary: {
            backgroundFilled: 'accent.base',
            border: 'accent.base',
            textFilled: 'common.black',
            textOutlined: 'common.black',
        },
    },
    fixedColors: {
        neutral: {
            backgroundFilled: 'neutral.lightest',
            border: 'neutral.light',
            textFilled: 'common.black',
            textOutlined: 'common.black',
        },
        black: {
            backgroundFilled: 'common.black',
            border: 'common.black',
            textFilled: 'common.white',
            textOutlined: 'common.black',
        },
        white: {
            backgroundFilled: 'common.white',
            border: 'common.white',
            textFilled: 'common.black',
            textOutlined: 'common.white',
        },
    },
    switchChipVariant: {
        default: {
            checked: {
                variant: 'filled',
                color: 'primary',
            },
            unchecked: {
                variant: 'outlined',
                color: {
                    backgroundFilled: 'common.white',
                    backgroundOutlined: 'common.white',
                    border: 'neutral.light',
                    textFilled: 'common.black',
                    textOutlined: 'common.black',
                },
            },
        },
        alternative: {
            checked: {
                variant: 'filled',
                color: 'primary',
            },
            unchecked: {
                variant: 'filled',
                color: {
                    backgroundFilled: 'neutral.tint.100',
                    border: 'primary',
                    textFilled: 'common.black',
                    textOutlined: 'primary',
                },
            },
        },
    },
    dismissIconSize: 12,
};
